import { css, jsx } from '@emotion/core';
import React from 'react';

import Table from '@/src/shared/components/Table';
import { colors } from '@/styles';

const style = {
  table: css`
    [data-row-key='15'],
    [data-row-key='16'],
    .ant-table-thead > tr {
      background-color: ${colors.accentGrayUltralight};
    }
    .tcol-right {
      text-align: right;
    }
  `,
  tableTitle: css`
    font-weight: bold;
    text-align: center;
    font-size: 2rem;
    color: ${colors.primaryBlue};
  `,
};

const percentify = num => {
  if (!num) return null;
  return `${(num * 100).toFixed(2)}%`;
};
const numberfy = num => {
  if (!num) return null;
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
const columns = [
  {
    title: 'Direct Written Premium ($000s omitted)',
    dataIndex: 'Dpw',
    className: 'tcol-right',
    render: (value, record) => {
      const numberValue = numberfy(value);
      return record.isTotal ? <b>{numberValue}</b> : numberValue;
    },
  },
  {
    title: 'Market Share',
    dataIndex: 'MarketShare',
    render: (value, record) => {
      const percentValue = percentify(value);
      return record.isTotal ? <b>{percentValue}</b> : percentValue;
    },
  },
  {
    title: 'Cumulative Market Share',
    dataIndex: 'CumulativeMarketShare',
    render: value => percentify(value),
    className: 'tcol-right',
  },
];

function TopWriters(props) {
  const { writersData } = props;
  const hasData = Boolean(writersData.length);
  const globals = {
    IndustryType: '',
    ReportYear: '',
    TotalDpw: 0,
    CumulativeDpw: '0',
    MarketShare: '0%',
    State: '',
  };
  const firstCol = {
    title: '',
    dataIndex: 'Company',
    render: (value, record) => {
      if (record.isTotal) return <b>{value}</b>;
      return value;
    },
  };
  if (hasData) {
    const [first] = writersData;
    const reportYear = Number(first.ReportYear) - 1;
    globals.IndustryType = first.IndustryType;
    globals.ReportYear = reportYear.toString();
    globals.TotalDpw = first.TotalDpw;
    globals.State = first.State;
    globals.CumulativeDpw = writersData.reduce((acc, cur) => acc + cur.Dpw, 0);
    globals.MarketShare = writersData.reduce((acc, cur) => acc + cur.MarketShare, 0);
    firstCol.title = first.IndustryType;
  }

  // ReportYear: 2018
  // IndustryType: "Medical Malpractice"
  // State: "California"
  // Company: "Doctors Company Exchange Group"
  // Dpw: 179443
  // CumulativeDpw: 179443
  // TotalDpw: 760296
  // MarketShare: 0.23601728800362
  // CumulativeMarketShare: 0.23601728800362
  return (
    <Table
      columns={[firstCol, ...columns]}
      css={style.table}
      size="small"
      pagination={false}
      title={() => (
        <h4 css={style.tableTitle}>
          <span>General Individual State Profile - {globals.State}</span>
          <br />
          <span>Top Fifteen Group or Individual Writers - {globals.ReportYear}</span>
        </h4>
      )}
      dataSource={[
        ...writersData,
        {
          Company: 'TOTAL TOP FIFTEEN',
          Dpw: globals.CumulativeDpw,
          MarketShare: globals.MarketShare,
          CumulativeMarketShare: null,
          isTotal: true,
        },
        {
          Company: 'TOTAL INDUSTRY',
          Dpw: globals.TotalDpw,
          MarketShare: 1,
          CumulativeMarketShare: null,
          isTotal: true,
        },
      ]}
    />
  );
}

TopWriters.propTypes = {};

export default TopWriters;
